import PageBox from "PFComponents/box/page_box";
import { Button } from "PFComponents/button";
import ButtonLink from "PFComponents/button/button_link";
import DataTable from "PFComponents/data_table/data_table";
import SimplePagination from "PFComponents/pagination/simple_pagination";
import api from "PFCore/api";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./collaborators_configs.modules.scss";

const CollaboratorsConfigsPage = ({ collaboratorsConfigs, fetchCollaboratorsConfigs }) => {
  const { t } = useTranslation("collaboratorsConfigs", { keyPrefix: "list" });
  const { entries, meta } = collaboratorsConfigs;

  const renderActions = (item) => (
    <div className={css.actionButtons}>
      <ButtonLink kind="secondary" small href={`/admin/collaborators_configs/${item.id}/edit`}>
        {t("translation:edit")}
      </ButtonLink>
      <Button
        kind="danger"
        small
        onClick={() => {
          if (confirm(t("translation:sureToDelete", { key: item.name }))) {
            api({
              url: `admin/participation_rules/${item.id}`,
              method: "DELETE"
            }).then(() => fetchCollaboratorsConfigs());
          }
        }}
      >
        {t("translation:remove")}
      </Button>
    </div>
  );

  const cellRenderer = (attribute) => <span>{attribute}</span>;

  return (
    <div className={css.wrapper}>
      <div className={css.header}>
        <h1>{t("title")}</h1>
        <ButtonLink href="/admin/collaborators_configs/new">{t("createNewConfig")}</ButtonLink>
      </div>
      <PageBox>
        {entries.length > 0 ? (
          <DataTable
            style={{ whiteSpace: "nowrap" }}
            columns={[
              {
                headerName: t("columns.name"),
                renderCell: (data) => cellRenderer(data.name)
              },
              {
                headerName: t("columns.actions"),
                renderCell: (data) => renderActions(data),
                narrow: true
              }
            ]}
            data={entries}
          />
        ) : (
          <div className={css.notFound}>
            <div className={css.notFoundText}>{t("configNotFound")}</div>
            <ButtonLink href="/admin/collaborators_configs/new">{t("createNewConfig")}</ButtonLink>
          </div>
        )}
      </PageBox>
      <div style={{ marginTop: "30px" }}>
        <SimplePagination
          currentPage={meta?.page}
          totalPages={meta?.totalPages}
          handleClick={fetchCollaboratorsConfigs}
        />
      </div>
    </div>
  );
};

CollaboratorsConfigsPage.propTypes = {
  collaboratorsConfigs: PropTypes.shape({
    meta: PropTypes.object,
    entries: PropTypes.array
  }),
  fetchCollaboratorsConfigs: PropTypes.func.isRequired
};

export default CollaboratorsConfigsPage;
